import type { HttpTransport } from "@common/api/transport";

import type {
  FrostEstimationParams,
  FrostEstimationResponse
} from "types/FrostEstimations";

export const createFrostEstimationsApi = (http: HttpTransport) => ({
  createFrostEstimation: ({ gardenId, latitude, longitude }: FrostEstimationParams) =>
    http.post<FrostEstimationResponse>(`/api/gardens/${gardenId}/frost_estimation`, {
      latitude,
      longitude
    }),

  fetchFrostEstimation: ({ gardenId, latitude, longitude }: FrostEstimationParams) =>
    http.get<FrostEstimationResponse | Record<string, never>>(
      `/api/gardens/${gardenId}/frost_estimation`,
      { queryParams: { latitude, longitude } }
    )
});
